import React from 'react';

export function AskTripExplained() {

    return <div className="ask-content p-4 container">

        <div className='row'>

            <div className="col-12 col-md-6 ask-explained">
                <div className='flow mb-5'>

                    <h1>What is AskTrip?</h1>

                    <p>AskTrip is a cutting-edge tool designed to quickly and reliably answer clinical questions using high-quality, evidence-based content. Powered by advanced AI and large language models (LLMs), it delivers rapid, trustworthy answers - helping clinicians make better decisions, faster.</p>

                    <p>But AskTrip is more than just a smart tool - it's the product of decades of experience.</p>

                </div>
                <div className='flow mb-5'>

                    <h2 className='h3 bold text-primary'>A Legacy of Answering Clinical Questions</h2>

                    <p>Trip was originally created in the late 1990s to support ATTRACT, a clinical Q&A service for GPs in Gwent, South Wales. Its success led to Trip becoming a trusted partner in expanding Q&A services across all of Wales, England, and further afield.</p>

                    <p>Over the years, the Trip team has manually answered more than 10,000 clinical questions, building deep expertise in interpreting real-world clinical queries and finding the most relevant, high-quality evidence to support frontline decision-making. This unparalleled experience forms the foundation of AskTrip. Take a peek at our 2001 BMJ paper <a href="https://pmc.ncbi.nlm.nih.gov/articles/PMC26559/" target="_blank" rel="noopener noreferrer">Just in time information for clinicians: a questionnaire evaluation of the ATTRACT project</a></p>
                </div>
                <div className='flow mb-5'>

                    <h2 className='h3 bold text-primary'>How It Works – Step by Step</h2>

                    <ol>
                        <li>
                            <strong>You Ask:</strong> Submit your clinical question in natural language - just as you'd ask a colleague.
                        </li>
                        <li>
                            <strong>AI Processes Your Question:</strong> Our AI system interprets the query, identifies key clinical components, and searches Trip's curated, high-quality evidence database.
                        </li>
                        <li>
                            <strong>Evidence Is Retrieved and Synthesised:</strong> The system prioritises trusted sources such as guidelines and systematic reviews. It then synthesises the findings into a clear, concise answer tailored to your query.
                        </li>
                        <li>
                            <strong>You Get a Clear, Referenced Answer:</strong> Within seconds, you receive a structured response - with citations - designed to support confident, evidence-based clinical decision-making.
                        </li>
                    </ol>
                </div>

            </div>

            <div className='col-12 col-md-6'>
                <img src="/explained.png" className='img-fluid' alt="AskTrip Explained" />
            </div>

        </div>

    </div>;

}
